export class AssetEmailDto {
    to: string;
    from: string;
    subject: string;
    additionalBody: string;

    constructor(){}
}



// WEBPACK FOOTER //
// ./src/app/client-core/dtos/asset-email.model.ts